import { render, staticRenderFns } from "./RemoteView.vue?vue&type=template&id=7c6e05fa"
import script from "./RemoteView.vue?vue&type=script&lang=js"
export * from "./RemoteView.vue?vue&type=script&lang=js"
import style0 from "./RemoteView.vue?vue&type=style&index=0&id=7c6e05fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports